import * as React from 'react';
import GridContainer from "../GenericComponents/Grids/GridContainer";
import {createBreadCrumbBasedOnPage} from "../../Utils/HelperFunctions";
import * as actionTypes from "../../store/action";
import {connect} from "react-redux";
import {Button, ButtonProps, CheckboxProps, Form, Icon, Popup, Radio} from "semantic-ui-react";
import fileDownload from "js-file-download";
import {toast} from "react-toastify";
import ProjectApi from "../../services/project-service";


interface ViewProjectsProps {
    setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => void;
}

interface ViewProjectsState {
    buttonUploading: Map<string, boolean>
    bulkUploadTemplateChoice: string
    uploadFile: any
    uploadButtonClicked: boolean
}

class ViewProjects extends React.Component<ViewProjectsProps,ViewProjectsState> {
    private projectClient: ProjectApi;
    constructor(props: ViewProjectsProps) {
        super(props);
        this.state = {
            buttonUploading: new Map<string, boolean>(),
            bulkUploadTemplateChoice: '',
            uploadFile: {},
            uploadButtonClicked: false
    };
        this.projectClient = new ProjectApi();
    }
    componentDidMount(): void {
        this.props.setBreadCrumbPath(createBreadCrumbBasedOnPage(window.location.pathname.split('/').filter(x => x)));
        let { buttonUploading } = this.state;
        buttonUploading.set('bulkUpload', false);
        this.setState({buttonUploading, bulkUploadTemplateChoice: 'project'});
    }

    downloadOrUploadFile = (event: React.MouseEvent<HTMLButtonElement>, data:ButtonProps) => {
        if(data.actionType === 'download') {
            this.projectClient.downloadProjectTemplate(this.state.bulkUploadTemplateChoice)
                .then((response:any) => {
                    fileDownload(response.data,response.headers["content-disposition"].split("=")[1]);
                    toast.success('Successfully downloaded ' + response.headers["content-disposition"].split("=")[1]);
                });
        }
        else {
            /*let { buttonUploading } = this.state;
            if(buttonUploading.has('bulkUpload')) {
                buttonUploading.set('bulkUpload', true);
            }*/
            this.setState({uploadButtonClicked: true});
        }
    };

    updateBulkUploadLoadingStatus = (loadingStatus:boolean) => {
        let {buttonUploading} = this.state;
        if (buttonUploading.has('bulkUpload')) {
            buttonUploading.set('bulkUpload', loadingStatus);
        }
        this.setState({buttonUploading, uploadButtonClicked: loadingStatus});
    };

    getProjectIntermediateBulkUploadPopup = () => {
        return (
            <Form>
                <Form.Field>
                    <h4>Please select Template to download or proceed to Upload Document:</h4>
                </Form.Field>
                <div className={'bulkUploadButtonSection'}>
                    <Button.Group floated={'right'}>
                        <Button icon={true} labelPosition='left' actionType={'download'} onClick={this.downloadOrUploadFile}>
                            <Icon name={'download'} />
                            Download {this.state.bulkUploadTemplateChoice.toUpperCase()} Template
                        </Button>
                        <Button.Or />
                        <Button positive={true} icon={true} labelPosition='right' actionType={'upload'} loading={this.state.buttonUploading.get('bulkUpload')} onClick={this.downloadOrUploadFile}>
                            Upload
                            <Icon name={'upload'} />
                        </Button>
                    </Button.Group>
                </div>
            </Form>
        );
    };

    specialUploadPopup = () => {
        return (
            <Popup
                trigger={<Button type="button" loading={this.state.buttonUploading.get('bulkUpload')} className={"blue"}>
                    Import
                </Button>}
                content={this.getProjectIntermediateBulkUploadPopup}
                on={'click'}
                wide={'very'}
            />
        );
    };

    render() {
        return (
            <GridContainer
                getGridDataUrl={'/api/auth/viewGridData/project'}
                addRecordUrl={'/api/auth/saveGridRecord/project'}
                editRecordUrl={'/api/auth/editGridRecord/project'}
                deleteRecordUrl={'/api/auth/removeGridRecord/project'}
                gridPaginated={true}
                formEditing={true}
                showUtilityColumns={true}
                exportLink={'viewGridData/project'}
                gridTitle={'View Projects'}
                gridId={'projectGrid'}
                freezeColumn
                bulkUpload={true}
                specialtyBulkUpload={this.specialUploadPopup()}
                typeForSuperClass={'project'}
                specialtyUploadClicked={this.state.uploadButtonClicked}
                updateBulkUploadLoadingStatus={this.updateBulkUploadLoadingStatus}
            />
        );
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        setBreadCrumbPath: (breadCrumbPath:BreadCrumb[]) => dispatch(
            {type: actionTypes.SET_BREADCRUMB_PATH, payload: breadCrumbPath})
    }
};

export default connect(null, mapDispatchToProps)(ViewProjects);